import React from 'react';
import { Link } from 'react-router-dom';
import './Error.scss';

export default function Error(props) {
  return <div id="content">
    <div id="error-page">
      <div id="error-container">
        <div id="error-page-image-wrapper">
          <div id="error-page-image"></div>
          <div id="error-page-rey"></div>
        </div>
        <div className="error-title">{props.title}</div>
        <div className="error-message">{props.message}</div>
        <div id="action-button">
          <Link to={props.action.link} className="button-with-link">
            <button className="button">{props.action.text}</button>
          </Link>
        </div>
      </div>
      <div id="error-page-game-logo"></div>
    </div>
  </div>;
}
